import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_COUNSELLOR_API_BASE_URL;

export const initiateIVRCall = async (doctor_id, customer_id) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/ivr/call`, {
            doctor_id,
            customer_id,
        });

      
        return response.data;
    } catch (error) {
        console.error('Error initiating IVR call:', error.response || error.message);
        throw error;
    }
};